import React from 'react';
import { withTheme } from 'styled-components';
export var ServiciosPublicosIcon = function ServiciosPublicosIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "262px",
    height: "262px",
    viewBox: "0 0 262 262",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Servicios pu\u0301blicos"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Servicios-pu\u0301blicos",
    transform: "translate(-52.000000, -3.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "13"
  }, React.createElement("g", {
    id: "Servicios_p\xFAblicos",
    transform: "translate(59.000000, 9.000000)"
  }, React.createElement("g", {
    id: "Building-Construction__x2F__Buildings__x2F__buildings_1_"
  }, React.createElement("g", {
    id: "Group_40_1_"
  }, React.createElement("g", {
    id: "buildings_1_"
  }, React.createElement("path", {
    d: "M0,103.34 C0,100.36 2.42,97.94 5.4,97.94 L113.43,97.94 C116.41,97.94 118.83,100.36 118.83,103.34 L118.83,243.78 C118.83,246.76 116.41,249.18 113.43,249.18 L5.4,249.18 C2.42,249.18 0,246.76 0,243.78 L0,103.34 Z",
    id: "Rectangle-path_21_1_"
  }), React.createElement("path", {
    d: "M97.22,97.93 L97.22,38.51 C97.22,35.53 94.8,33.11 91.82,33.11 L27,33.11 C24.02,33.11 21.6,35.53 21.6,38.51 L21.6,97.93",
    id: "Shape_387_1_"
  }), React.createElement("line", {
    x1: "54.01",
    y1: "33.12",
    x2: "54.01",
    y2: "0.71",
    id: "Shape_388_1_"
  }), React.createElement("path", {
    d: "M151.24,70.93 C151.24,67.95 153.66,65.53 156.64,65.53 L243.06,65.53 C246.04,65.53 248.46,67.95 248.46,70.93 L248.46,243.78 C248.46,246.76 246.04,249.18 243.06,249.18 L156.64,249.18 C153.66,249.18 151.24,246.76 151.24,243.78 L151.24,70.93 L151.24,70.93 Z",
    id: "Rectangle-path_22_1_"
  }), React.createElement("line", {
    x1: "172.84",
    y1: "97.93",
    x2: "226.86",
    y2: "97.93",
    id: "Shape_389_1_"
  }), React.createElement("line", {
    x1: "172.84",
    y1: "130.34",
    x2: "226.86",
    y2: "130.34",
    id: "Shape_390_1_"
  }), React.createElement("line", {
    x1: "172.84",
    y1: "162.75",
    x2: "226.86",
    y2: "162.75",
    id: "Shape_391_1_"
  }), React.createElement("line", {
    x1: "172.84",
    y1: "195.16",
    x2: "226.86",
    y2: "195.16",
    id: "Shape_392_1_"
  }), React.createElement("line", {
    x1: "21.6",
    y1: "130.34",
    x2: "97.22",
    y2: "130.34",
    id: "Shape_393_1_"
  }), React.createElement("line", {
    x1: "21.6",
    y1: "162.75",
    x2: "97.22",
    y2: "162.75",
    id: "Shape_394_1_"
  }), React.createElement("line", {
    x1: "21.6",
    y1: "195.16",
    x2: "97.22",
    y2: "195.16",
    id: "Shape_395_1_"
  }), React.createElement("line", {
    x1: "43.21",
    y1: "65.34",
    x2: "75.62",
    y2: "65.34",
    id: "Shape_396_1_"
  }), React.createElement("path", {
    d: "M64.81,249.18 L64.81,222.17 C64.81,219.19 62.39,216.77 59.41,216.77 L48.61,216.77 C45.63,216.77 43.21,219.19 43.21,222.17 L43.21,249.18",
    id: "Shape_397_1_"
  }), React.createElement("path", {
    d: "M216.06,249.18 L216.06,222.17 C216.06,219.19 213.64,216.77 210.66,216.77 L199.86,216.77 C196.88,216.77 194.46,219.19 194.46,222.17 L194.46,249.18",
    id: "Shape_398_1_"
  }))))))));
};
export default withTheme(ServiciosPublicosIcon);